import { render, staticRenderFns } from "./addDedicatedDietRegime.vue?vue&type=template&id=655983c6&scoped=true"
import script from "./addDedicatedDietRegime.vue?vue&type=script&lang=js"
export * from "./addDedicatedDietRegime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655983c6",
  null
  
)

export default component.exports